import React, { HTMLInputTypeAttribute } from "react";
import './InputText.css';

interface IInputTextProps{
    value: string;
    label: React.ReactNode;
    onChange: (next: string)=>void;
    className?: string;
    error?:string;
    type?:HTMLInputTypeAttribute;
}

export const InputText = ({value, onChange, label, className, error, type}: IInputTextProps)=>{
    return <div className={`commonInputText ${error ? 'commonInputText--error' : ''} ${className || ''}`}>
    <div className="commonInputText_label">
        {label}
    </div>
    <input type={type || 'text'} value={value} onChange={(e)=>onChange(e.target.value)} className="commonInputText_field" />
    <div className="commonInputText_error">
        {error}
    </div>
</div>
}
